import { StorageKey } from './types';
import { useStorage } from './useStorage';

export function useLocalStorage<TKey extends StorageKey>(key: TKey) {
  return useStorage<TKey>(key, global.localStorage);
}
